import { api } from "app/data/api";

interface Contact {
  zipcode: string;
  address: string;
  number: string;
  neighborhood: string;
  complement: string;
  city: string;
  uf: string;
  telephone: string;
  cellphone: string;
}

interface Institution {
  institution: string;
  unit: string;
  department: string;
}

export const getAllProfiles = async () => {
  return await api.get("/user/listAllProfiles");
};

export const listAllProfiles = async () => {
  return await api.get("/user/listProfiles");
};

export const getUserProfiles = async () => {
  return await api.get("/user/userProfiles", {});
};

export const getAvaliableUserProfiles = async () => {
  return await api.get("/user/userAvaliableProfiles");
};

export const requestNewProfile = async (
  profileId: number,
  managerEmail: string,
  orcid: string,
  userfunction: string,
  institution: string
) => {
  return await api.post("/user/requestProfile", {
    profileId,
    managerEmail,
    orcid,
    function: userfunction,
    institution,
  });
};

export const changePassword = async (
  password: string,
  newPassword: string,
  retypeNewPassword: string
) => {
  return await api.post("/user/changePassword", {
    password,
    newPassword,
    retypeNewPassword,
  });
};

export const getContactInfo = async (userId?: number) => {
  return await api.get("/user/getContactInfo", {
    params: {
      userId,
    },
  });
};

export const updateContact = async (contactData: Contact) => {
  return await api.post("/user/updateUserContact", {
    ...contactData,
  });
};

export const getInstitutionInfo = async (userId?: number) => {
  return await api.get("/user/getInstitutionInfo", {
    params: {
      userId,
    },
  });
};

export const updateInstitution = async (institutionData: Institution) => {
  return await api.post("/user/updateUserInstitution", {
    ...institutionData,
  });
};
